import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import translate from "src/functions/translate";
import Benefit from "src/icons/Benefit";
import Care from "src/icons/Care";
import Free from "src/icons/Free";
import Tax from "src/icons/Tax";
import Watch from "src/icons/Watch";
import Yoga from "src/icons/Yoga";
import Yogamat from "src/icons/Yogamat";
import { sButton } from "src/styles/sButton.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sWhyToUseCard } from "src/styles/sWhyToUseCard.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
};

function WhyToUseCompanies({ style, className }: Props) {
  const { locale: lang, push } = useRouter();

  return (
    <>
      <div
        className={composeClassNames([
          sWhyToUseCard,
          className,
          "whyToUse-cards",
        ])}
      >
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Free />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`First month free`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Try a monthly subscription for your employees for free.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Benefit />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Benefit program`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Take advantage of interesting discounts and bonuses from our partners.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Care />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Caring for your people`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p style={{ fontSize: `13px` }}>
              <Translate
                tKey={`A satisfied, relaxed and focused team can handle tasks better.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Yogamat />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`We will equip your office`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`We will prepare a place where your people can relax and regenerate together.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Watch />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Home office just fine`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Exercise also from the comfort of home according to current needs.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Yoga />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Individual sessions`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Our instructors also provide individual care and guidance.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Tax />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`You save on taxes`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p style={{ fontSize: `13px` }}>
              <Translate
                tKey={`You can save up to 26% by providing an employee benefit.`}
              />
            </p>
          </div>
        </div>
      </div>
      <div className={"show-all"}>
        <Button
          variant={`primary`}
          className={composeClassNames([sButton, className])}
          onClick={() =>
            (window.location.href = translate(
              "mailto:pavol.hudran@anandita.life?Subject=Anandita inquiry&body=Hi,%0A%0AI would like to contact you with a inquiry.%0AI have this request of you: %0A%0ABest regards",
              lang
            ))
          }
          style={style}
        >
          <Translate tKey={`Contact us with an inquiry`} />
        </Button>
      </div>
    </>
  );
}

export default WhyToUseCompanies;
